import React, { useContext, useTransition } from 'react'
import styled from 'styled-components'
import Creator_Title_Row from '../creator/Creator_Title_Row'
import { ReportStyleContext } from '../../../../context/ReportStyleContext'
import { Builder_, Dropdown_, Input_, Slider_ } from 'monica-alexandria'
import { useTranslation } from 'react-i18next'

const RowMedia = styled.div``

const RowMediaBody = styled.div`
    
`

const RowMediaGrid = styled.div`
display: grid;
    grid-template-columns: ${p => p.grid === 'full' ? '1fr' :p.grid === 'split' ? '1fr 1fr' : '1fr 1fr 1fr' };

    img{
        width: 100%;
    }
`

export default function Row_Media(props) {

    const {t} = useTranslation()

    const {reportStyle} = useContext(ReportStyleContext);

  return (
        <RowMedia key={props.key} id={props.id}>
            <RowMediaBody presetStyle={reportStyle}>
                <Creator_Title_Row viewMode={props.viewMode} title={props.title} onDelete={props.onDeleteComment} onEdit={props.onEditComment} />
                <RowMediaGrid grid={props.grid}>
                    <img src={props.image} />
                </RowMediaGrid>
            </RowMediaBody>
        </RowMedia>
  )
}
